/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./notifications.scss');

const deps = [require('data/service/notifications').name];

module.exports = angular
  .module('bench.ui.notifications', deps)

  .directive('blNotifications', () => ({
    restrict: 'E',
    scope: {},
    bindToController: true,
    template: require('./notifications.html'),
    controller: require('./notificationsCtrl.js'),
    controllerAs: 'vm',
  }));
